export function toggleAffiliationRole(
  roles: string[],
  role: string,
  checked: boolean | 'indeterminate',
) {
  if (checked === true) return roles.includes(role) ? roles : [...roles, role]

  return roles.filter((candidate) => candidate !== role)
}
